module.exports = __webpack_public_path__ + "img/message-circle-svgrepo-com.c489fb39.svg";